import { cryptoRegister, fetchProvinces, register } from '@ogsnetwork/opp-redux-lib';
import lodash from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, usePrevious } from '../index';
import { combineValidationErrors, useStateWithValidation } from '../validation';
import { validateEmail, validatePassword, validateUsername } from './validation';
export function useRegister(props) {
    const dispatch = useAppDispatch();
    const authentication = useAppSelector((state) => state.authentication);
    const provinces = lodash.sortBy(useAppSelector((state) => state.provinces.provinces), (province) => province.name);
    const previousStatus = usePrevious(authentication.status);
    const email = useStateWithValidation(validateEmail, '');
    const password = useStateWithValidation(validatePassword, '');
    const [province, setProvince] = useState('');
    const username = useStateWithValidation(validateUsername, '');
    const isValid = email.isValid &&
        !email.isPristine &&
        password.isValid &&
        !password.isPristine &&
        username.isValid &&
        !username.isPristine &&
        province !== '';
    const validationErrors = combineValidationErrors(email.errors, password.errors, username.errors);
    const dispatchRegister = useCallback(() => {
        if (isValid) {
            dispatch(register({ email: email.value, password: password.value, province, username: username.value }));
        }
    }, [email.value, password.value, username.value, province, isValid]);
    useEffect(() => {
        dispatch(fetchProvinces());
    }, []);
    useEffect(() => {
        var _a, _b;
        if (authentication.status === 'loggedIn' && previousStatus === 'registering') {
            email.setValue('');
            password.setValue('');
            setProvince('');
            username.setValue('');
            (_a = props === null || props === void 0 ? void 0 : props.onRegister) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        if (authentication.status === 'error' && previousStatus === 'registering') {
            (_b = props === null || props === void 0 ? void 0 : props.onError) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [authentication.status]);
    return {
        provinces,
        email: email.value,
        password: password.value,
        province,
        username: username.value,
        dispatchRegister,
        setEmail: email.setValue,
        setPassword: password.setValue,
        setProvince,
        setUsername: username.setValue,
        validateEmail,
        disableSignup: !isValid,
        error: validationErrors !== null && validationErrors !== void 0 ? validationErrors : authentication.error
    };
}
export function useCryptoRegister(props) {
    const dispatch = useAppDispatch();
    const authentication = useAppSelector((state) => state.authentication);
    const previousStatus = usePrevious(authentication.status);
    function dispatchCryptoRegister(address, signature) {
        dispatch(cryptoRegister({ address, signature }));
    }
    useEffect(() => {
        var _a, _b;
        if (authentication.status === 'loggedIn' && previousStatus === 'registering') {
            (_a = props === null || props === void 0 ? void 0 : props.onRegister) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        if (authentication.status === 'error' && previousStatus === 'registering') {
            (_b = props === null || props === void 0 ? void 0 : props.onError) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [authentication.status]);
    return {
        dispatchCryptoRegister,
        error: authentication.error
    };
}
